import React from 'react';
import {SPACE, View} from '@lookiero/aurora';
import {Logo as LookieroLogo} from '../Logo';

export const NavLogo: React.FC = () => {
  return (
    <View testID="navbar-logo" paddingHorizontal={SPACE.SPACE_4}>
      {<LookieroLogo />}
    </View>
  );
};
